import "./Signin.css"
import { Outlet } from "react-router-dom";

function Signin() {

  return(
    <>
    <div className="flex flex-col justify-between h-[100vh]">
    <div className="header">

    </div>
    <Outlet />
    <div className="footer-bg"></div>
    </div>
      </>
  )
}

export default Signin